export const quantityReasonCodes = [
  { label: 'Insufficient product to install all ads', value: 1, numericEquivalent: 1 },
  { label: 'Insufficient ads received to match required quantity', value: 2, numericEquivalent: 2 },
  { label: 'Not enough carts to install ads shipped', value: 3, numericEquivalent: 3 },
  { label: 'Manager limited quantity installed', value: 4, numericEquivalent: 4 },
]
